import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { IContractingPaymentState, PaymentDataType } from 'v3/data/store/payment/types';

export const filtersPaymentInitialState = {
  cpf: '',
  rowsPerPage: 20,
  page: 0,
  finalDate: undefined,
  startDate: undefined,
  status: undefined,
  storeIds: [],
};

const paymentData: PaymentDataType = {
  contractingKey: '',
  paidInstallments: 0,
  paymentDate: '',
  paymentReceived: false,
};
export const paymentInitialState: IContractingPaymentState = {
  list: {
    items: [],
    count: 0,
  },
  listView: {
    items: [],
    count: 0,
  },
  generateAllContractingList: {
    totalContractings: 0,
    initialStoreIds: [],
    initialStoreIdsRequest: true,
  },
  contractingKey: '',
  contractingState: ContractingStateEnum.ContractingStarted,
  filter: filtersPaymentInitialState,

  tokenValid: false,
  selectedContracting: {
    contractingKey: '',
    createdAt: '',
    contractSignDate: '',
    person: { cpf: '', fullName: '', phoneNumber: '', email: '', phoneAreaCode: '' },
    status: ContractingStateEnum.ContractingStarted,
    creditSimulation: {
      store: {
        name: '',
        cnpj: '',
      },
      product: {
        name: '',
        price: 0,
        discount: 0,
      },
      device: {
        imei: '',
        ean: '',
        invoiceSeries: '',
        invoiceNumber: '',
      },
      financing: {
        requestedAmount: 0,
        inputValue: 0,
        releasedAmount: 0,
        FinancingDetails: {
          accessoriesValue: 0,
          insuranceName: '',
          insuranceValue: 0,
        },
      },
    },
    ContractingEvents: [],
  },
  timeRemaining: '',
  paymentData,
};
